/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  HoundsRestricted,
  HoundsRestrictedInterface,
  Constructor,
} from "../HoundsRestricted";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "staminaLastUpdate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32",
                    name: "staminaValue",
                    type: "uint32",
                  },
                ],
                internalType: "struct Hound.Stamina",
                name: "stamina",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "lastBreed",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "externalBreedingFee",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "availableToBreed",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Breeding",
                name: "breeding",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "maleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "femaleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "generation",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "birthDate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "specie",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32[72]",
                    name: "geneticSequence",
                    type: "uint32[72]",
                  },
                  {
                    internalType: "string",
                    name: "extensionTraits",
                    type: "string",
                  },
                ],
                internalType: "struct Hound.Identity",
                name: "identity",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "string",
                    name: "token_uri",
                    type: "string",
                  },
                  {
                    internalType: "uint256",
                    name: "runningOn",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "custom",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Profile",
                name: "profile",
                type: "tuple",
              },
            ],
            internalType: "struct Hound.Struct",
            name: "defaultHound",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "externalBreedingFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedingCooldownCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "breedingCooldown",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedingCooldownTimeUnit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "refillBreedingCooldownCost",
                type: "uint256",
              },
            ],
            internalType: "struct Hound.ConstructorBreeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "staminaRefillCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "staminaRefill1x",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaPerTimeUnit",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "staminaCap",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.ConstructorStamina",
            name: "stamina",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            components: [
              {
                internalType: "address",
                name: "restricted",
                type: "address",
              },
              {
                internalType: "address",
                name: "minter",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsModifier",
                type: "address",
              },
              {
                internalType: "address",
                name: "zerocost",
                type: "address",
              },
              {
                internalType: "address",
                name: "hounds",
                type: "address",
              },
              {
                internalType: "address",
                name: "payments",
                type: "address",
              },
              {
                internalType: "address",
                name: "shop",
                type: "address",
              },
              {
                internalType: "address",
                name: "races",
                type: "address",
              },
              {
                internalType: "address",
                name: "genetics",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsInitializer",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsRenameHandler",
                type: "address",
              },
            ],
            internalType: "struct ConstructorBoilerplate.Struct",
            name: "boilerplate",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "renameFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "platformBreedFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedTransactionFeeCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "platformBreedFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedTransactionFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "renameFee",
                type: "uint256",
              },
            ],
            internalType: "struct ConstructorFees.Struct",
            name: "fees",
            type: "tuple",
          },
        ],
        internalType: "struct Constructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "parent1",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "parent2",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct Hound.Struct",
        name: "offspring",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "BreedHound",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "HoundBreedable",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "HoundBreedingStatusUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "HoundQueueStatusUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "stamina",
        type: "uint32",
      },
    ],
    name: "HoundStaminaUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct Hound.Struct",
        name: "hound",
        type: "tuple",
      },
    ],
    name: "NewHound",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "proposal",
            type: "string",
          },
          {
            internalType: "bool",
            name: "accepted",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "sessionActive",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct RenamingProposal.Struct",
        name: "renameProposal",
        type: "tuple",
      },
    ],
    name: "RenameProposal",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        internalType: "struct Hound.Struct",
        name: "defaultHound",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "externalBreedingFeeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "breedingCooldownCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "breedingCooldown",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "breedingCooldownTimeUnit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "refillBreedingCooldownCost",
            type: "uint256",
          },
        ],
        internalType: "struct Hound.ConstructorBreeding",
        name: "breeding",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "staminaRefillCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "staminaRefill1x",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "staminaPerTimeUnit",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCap",
            type: "uint32",
          },
        ],
        internalType: "struct Hound.ConstructorStamina",
        name: "stamina",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "minter",
            type: "address",
          },
          {
            internalType: "address",
            name: "houndsModifier",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "hounds",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "shop",
            type: "address",
          },
          {
            internalType: "address",
            name: "races",
            type: "address",
          },
          {
            internalType: "address",
            name: "genetics",
            type: "address",
          },
          {
            internalType: "address",
            name: "houndsInitializer",
            type: "address",
          },
          {
            internalType: "address",
            name: "houndsRenameHandler",
            type: "address",
          },
        ],
        internalType: "struct ConstructorBoilerplate.Struct",
        name: "boilerplate",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "renameFeeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "platformBreedFeeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "breedTransactionFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformBreedFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "breedTransactionFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "renameFee",
            type: "uint256",
          },
        ],
        internalType: "struct ConstructorFees.Struct",
        name: "fees",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "houndId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "newTokenURI",
        type: "string",
      },
      {
        internalType: "bool",
        name: "validation",
        type: "bool",
      },
    ],
    name: "handleHoundRename",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "houndId",
        type: "uint256",
      },
    ],
    name: "hound",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        internalType: "struct Hound.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "houndOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "hounds",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "staminaLastUpdate",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "staminaValue",
            type: "uint32",
          },
        ],
        internalType: "struct Hound.Stamina",
        name: "stamina",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lastBreed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "externalBreedingFee",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "availableToBreed",
            type: "bool",
          },
        ],
        internalType: "struct Hound.Breeding",
        name: "breeding",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maleParent",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "femaleParent",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "generation",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "birthDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "specie",
            type: "uint256",
          },
          {
            internalType: "uint32[72]",
            name: "geneticSequence",
            type: "uint32[72]",
          },
          {
            internalType: "string",
            name: "extensionTraits",
            type: "string",
          },
        ],
        internalType: "struct Hound.Identity",
        name: "identity",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "runningOn",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "custom",
            type: "bool",
          },
        ],
        internalType: "struct Hound.Profile",
        name: "profile",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "id",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "onId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        internalType: "struct Hound.Struct",
        name: "createdHound",
        type: "tuple",
      },
    ],
    name: "initializeHound",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "matingSeason",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "renamingProposals",
    outputs: [
      {
        internalType: "string",
        name: "proposal",
        type: "string",
      },
      {
        internalType: "bool",
        name: "accepted",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "sessionActive",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "staminaLastUpdate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32",
                    name: "staminaValue",
                    type: "uint32",
                  },
                ],
                internalType: "struct Hound.Stamina",
                name: "stamina",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "lastBreed",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "externalBreedingFee",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "availableToBreed",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Breeding",
                name: "breeding",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "maleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "femaleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "generation",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "birthDate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "specie",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32[72]",
                    name: "geneticSequence",
                    type: "uint32[72]",
                  },
                  {
                    internalType: "string",
                    name: "extensionTraits",
                    type: "string",
                  },
                ],
                internalType: "struct Hound.Identity",
                name: "identity",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "string",
                    name: "token_uri",
                    type: "string",
                  },
                  {
                    internalType: "uint256",
                    name: "runningOn",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "custom",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Profile",
                name: "profile",
                type: "tuple",
              },
            ],
            internalType: "struct Hound.Struct",
            name: "defaultHound",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "externalBreedingFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedingCooldownCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "breedingCooldown",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedingCooldownTimeUnit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "refillBreedingCooldownCost",
                type: "uint256",
              },
            ],
            internalType: "struct Hound.ConstructorBreeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "staminaRefillCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "staminaRefill1x",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaPerTimeUnit",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "staminaCap",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.ConstructorStamina",
            name: "stamina",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            components: [
              {
                internalType: "address",
                name: "restricted",
                type: "address",
              },
              {
                internalType: "address",
                name: "minter",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsModifier",
                type: "address",
              },
              {
                internalType: "address",
                name: "zerocost",
                type: "address",
              },
              {
                internalType: "address",
                name: "hounds",
                type: "address",
              },
              {
                internalType: "address",
                name: "payments",
                type: "address",
              },
              {
                internalType: "address",
                name: "shop",
                type: "address",
              },
              {
                internalType: "address",
                name: "races",
                type: "address",
              },
              {
                internalType: "address",
                name: "genetics",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsInitializer",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsRenameHandler",
                type: "address",
              },
            ],
            internalType: "struct ConstructorBoilerplate.Struct",
            name: "boilerplate",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "renameFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "platformBreedFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedTransactionFeeCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "platformBreedFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedTransactionFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "renameFee",
                type: "uint256",
              },
            ],
            internalType: "struct ConstructorFees.Struct",
            name: "fees",
            type: "tuple",
          },
        ],
        internalType: "struct Constructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_matingSeason",
        type: "bool",
      },
    ],
    name: "setMatingSeason",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type HoundsRestrictedConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HoundsRestrictedConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HoundsRestricted__factory extends ContractFactory {
  constructor(...args: HoundsRestrictedConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "HoundsRestricted";
  }

  deploy(
    input: Constructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<HoundsRestricted> {
    return super.deploy(input, overrides || {}) as Promise<HoundsRestricted>;
  }
  getDeployTransaction(
    input: Constructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): HoundsRestricted {
    return super.attach(address) as HoundsRestricted;
  }
  connect(signer: Signer): HoundsRestricted__factory {
    return super.connect(signer) as HoundsRestricted__factory;
  }
  static readonly contractName: "HoundsRestricted";
  public readonly contractName: "HoundsRestricted";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HoundsRestrictedInterface {
    return new utils.Interface(_abi) as HoundsRestrictedInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HoundsRestricted {
    return new Contract(address, _abi, signerOrProvider) as HoundsRestricted;
  }
}
